import { render, staticRenderFns } from "./MessageSignature.vue?vue&type=template&id=58710d6a&scoped=true&"
import script from "./MessageSignature.vue?vue&type=script&lang=js&"
export * from "./MessageSignature.vue?vue&type=script&lang=js&"
import style0 from "./MessageSignature.vue?vue&type=style&index=0&id=58710d6a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58710d6a",
  null
  
)

export default component.exports